export default {"id":"e6aef802","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}